// extracted by mini-css-extract-plugin
export default {"actionIcons":"TaskCommentsPanel_actionIcons__ldkJN"};